<template>
  <div :class="{'progress-60':progress>50,'progress-30':progress<=50}" class="pie-wrapper style-2">
    <span class="label">
      {{progress}}
      <span class="smaller">%</span>
    </span>
    <div class="pie">
      <div
        :class="{'red-border': percentProgress <= 50,'orange-border':percentProgress>50 && percentProgress<100,'green-border':percentProgress==100 }"
        :style="styleObject"
        class="left-side half-circle"
      ></div>
      <div
        :class="{'red-border': percentProgress <= 50,'orange-border':percentProgress>50 && percentProgress<100,'green-border':percentProgress==100 }"
        class="right-side half-circle"
      ></div>
    </div>
    <div class="shadow"></div>
  </div>
</template>

<script>
export default {
  name: "RingProgress",
  props: {
    progress: {
      required: true
    }
  },
  computed: {
    percentProgress() {
      if (this.progress < 0) {
        return 0;
      } else if (this.progress > 100) {
        return 100;
      } else {
        return this.progress;
      }
    },
    styleObject() {
      return {
        "-webkit-transform":
          "rotate(" +
          Math.round(this.percentProgress * 3.6) +
          "deg) !important",
        transform:
          "rotate(" + Math.round(this.percentProgress * 3.6) + "deg) !important"
      };
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/scss/variables.scss";

.red-border {
  border-color: red !important;
}
.orange-border {
  border-color: $orange !important;
}
.green-border {
  border-color: green !important;
}

// -- vars
$bg-color: #34495e;
$default-size: 10rem;
$label-font-size: $default-size / 4;
$label-font-size-redo: $default-size * 4;

// -- mixins
@mixin size($width, $height) {
  height: $height;
  width: $width;
}

@mixin draw-progress($progress, $color) {
  .pie {
    .half-circle {
      border-color: $color;
    }

    .left-side {
      transform: rotate($progress * 3.6deg);
    }

    @if $progress <= 50 {
      .right-side {
        display: none;
      }
    } @else {
      clip: rect(auto, auto, auto, auto);

      .right-side {
        transform: rotate(180deg);
      }
    }
  }
}

@mixin draw-progress--solid($progress, $color, $bg-color) {
  background: linear-gradient(to right, $color 50%, $bg-color 50%);

  &:before {
    @if $progress <= 50 {
      background: $bg-color;
      transform: rotate((100 - (50 - $progress)) / 100 * 360deg * -1);
    } @else {
      background: $color;
      transform: rotate((100 - $progress) / 100 * 360deg);
    }
  }
}

// -- selectors
*,
*:before,
*:after {
  box-sizing: border-box;
}

html,
body {
  background: #ecf0f1;
  color: #444;
  font-family: "Lato", Tahoma, Geneva, sans-serif;
  font-size: 16px;
  padding: 10px;
}

.set-size {
  font-size: 10em;
}

.charts-container {
  &:after {
    clear: both;
    content: "";
    display: table;
  }
}

.pie-wrapper {
  @include size($default-size, $default-size);
  float: left;
  margin: 15px;
  position: relative;

  &:nth-child(3n + 1) {
    clear: both;
  }

  .pie {
    @include size(100%, 100%);
    clip: rect(0, $default-size, $default-size, $default-size / 2);
    left: 0;
    position: absolute;
    top: 0;

    .half-circle {
      @include size(100%, 100%);
      border: ($default-size / 10) solid #3498db;
      border-radius: 50%;
      clip: rect(0, $default-size / 2, $default-size, 0);
      left: 0;
      position: absolute;
      top: 0;
    }
  }

  .label {
    background: $bg-color;
    border-radius: 50%;
    bottom: $label-font-size-redo / 10;
    color: #ecf0f1;
    cursor: default;
    display: block;
    font-size: $label-font-size;
    left: 0;
    position: absolute;
    right: 0;
    text-align: center;
    top: $label-font-size-redo / 10;
    height: fit-content;
    margin: auto;
    .smaller {
      color: #bdc3c7;
      font-size: 0.45em;
      vertical-align: super;
    }
  }

  .shadow {
    @include size(100%, 100%);
    border: $default-size / 10 solid #bdc3c7;
    border-radius: 50%;
  }

  &.style-2 {
    .label {
      background: none;
      color: #7f8c8d;

      .smaller {
        color: #bdc3c7;
      }
    }
  }

  &.progress-30 {
    @include draw-progress(30, #3498db);
  }

  &.progress-60 {
    @include draw-progress(60, #9b59b6);
  }

  &.progress-90 {
    @include draw-progress(90, #e67e22);
  }

  &.progress-45 {
    @include draw-progress(45, #1abc9c);
  }

  &.progress-75 {
    @include draw-progress(75, $cyan);
  }

  &.progress-95 {
    @include draw-progress(95, #e74c3c);
  }
  &.progress-100 {
    @include draw-progress(100, $pantoneBlue);
  }
}

.pie-wrapper--solid {
  border-radius: 50%;
  overflow: hidden;

  &:before {
    border-radius: 0 100% 100% 0 / 50%;
    content: "";
    display: block;
    height: 100%;
    margin-left: 50%;
    transform-origin: left;
  }

  .label {
    background: transparent;
  }

  &.progress-65 {
    @include draw-progress--solid(65, #e67e22, $bg-color);
  }

  &.progress-25 {
    @include draw-progress--solid(25, #9b59b6, $bg-color);
  }

  &.progress-88 {
    @include draw-progress--solid(88, #3498db, $bg-color);
  }
}
</style>


